import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { SelectTextColoredIcon } from "src/icons/select-text-colored-icon";
import { SelectTextIcon } from "src/icons/select-text-icon";
import { WriteIcon } from "src/icons/write-icon";
import { WriteIconActive } from "src/icons/write-icon-active";

interface Props {}

export const ChooseArticleType = (props) => {
  const [active, setActive] = useState("write");
  return (
    <>
      <Box display="flex" gap="16px" height="141px" alignSelf="stretch">
        <Box
          display="flex"
          flexDirection="column"
          flex="1 1 0"
          gap="8px"
          alignSelf="stretch"
          alignItems="center"
          sx={{
            cursor: "pointer",
            borderRadius: "8px",
            background: "#F9FAFC",
            padding: "24px",
            border:
              active === "write" ? "1px solid #5048E5" : "1px solid #E6E8F0",
          }}
          onClick={() => [props.getArticleChoice("write"), setActive("write")]}
        >
          {active === "write" ? (
            <WriteIconActive
              sx={{
                height: "32px !important",
                width: "32px !important",
              }}
            />
          ) : (
            <WriteIcon
              sx={{
                height: "32px !important",
                width: "32px !important",
              }}
            />
          )}

          <Typography
            fontFamily="Inter"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="500"
            color={active === "write" ? "#5048E5" : "#121828"}
          >
            Create Article
          </Typography>
          <Typography
            fontFamily="Inter"
            fontSize="12px"
            fontStyle="normal"
            fontWeight="400"
            color="#7B85AD"
          >
            Create a brief using data and let AI write the article for you to
            nail the search intent.
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          flex="1 1 0"
          gap="8px"
          alignSelf="stretch"
          alignItems="center"
          sx={{
            cursor: "pointer",
            borderRadius: "8px",
            background: "#F9FAFC",
            padding: "24px",
            border:
              active === "update" ? "1px solid #5048E5" : "1px solid #E6E8F0",
          }}
          onClick={() => [
            props.getArticleChoice("update"),
            setActive("update"),
          ]}
        >
          {active === "update" ? (
            <SelectTextColoredIcon
              sx={{
                height: "32px !important",
                width: "32px !important",
              }}
            />
          ) : (
            <SelectTextIcon
              sx={{
                height: "32px !important",
                width: "32px !important",
              }}
            />
          )}
          <Typography
            fontFamily="Inter"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="500"
            color={active === "update" ? "#5048E5" : "#121828"}
          >
            Update your Article
          </Typography>
          <Typography
            fontFamily="Inter"
            fontSize="12px"
            fontStyle="normal"
            fontWeight="400"
            color="#7B85AD"
            textAlign="center"
          >
            Our AI workflow with AI agents will audit, research, rewrite,
            optimize for E-E-A-T, and add internal links.
          </Typography>
        </Box>
      </Box>
    </>
  );
};
